import { all, call, put, takeEvery } from "redux-saga/effects";
import axios from "../services/admin";
import { REPORTS_GET_APPOINTMENTS } from "../constants/ActionTypes";
import { reportsSetAppointments } from "../actions";

function* fetchAppointments({ payload }) {
  try {
    const location = localStorage.getItem("business_location")
    const response = yield axios.get(`/appointments?location=`+location);
    yield put(reportsSetAppointments(response.data));
  } catch (error) {}
}

export default function* rootSaga() {
  yield all([takeEvery(REPORTS_GET_APPOINTMENTS, fetchAppointments)]);
}



// WEBPACK FOOTER //
// ./sagas/Reports.Saga.js